import { useEffect, useState } from 'react'
import Select from 'react-select'

const SelectField = (props) => {
  const {
    name,
    label,
    placeholder,
    options,
    formik,

    isMulti = false,
    isDisabled = false,
    isClearable = false,
    isSearchable = false,
    backspaceRemovesValue = true,
    closeMenuOnSelect = true,
    onChange = () => {},
  } = props

  const pValue = formik.values[name] || ''
  const touched = formik.touched[name]
  const error = formik.errors[name]

  const [selectedValue, setSelectedValue] = useState('')

  useEffect(() => {
    if (!pValue) return

    // console.log('pValue', pValue)

    const value = Array.isArray(pValue)
      ? // ? pValue.map(x =>( typeof x === 'string' ? { label: x, value: x } : { label: x.name, value: x.id }))
        pValue.map((x) =>
          typeof x === 'string'
            ? options.find((z) => z.value.toString() === x)
            : { label: x.name, value: x.id },
        )
      : options.find((x) => x.value.toString() === pValue.toString())

    // console.log('value', value)

    setSelectedValue(value)
  }, [options, pValue])

  const handleChange = (val) => {
    const newVal = Array.isArray(val) ? val.map((x) => x.value) : val.value

    setSelectedValue(val)
    formik.setFieldValue(name, newVal)
    onChange({ value: newVal })
  }

  const handleBlur = () => {
    // formik.setTouched(name, true);
  }

  // console.log('YY', name, selectedValue, pValue, options)

  return (
    <div className="input-field-wrapper select-field">
      {label && (
        <label className="input-label" htmlFor={name} error={error}>
          {label}
        </label>
      )}

      <Select
        classNamePrefix="react-select"
        placeholder={placeholder}
        options={options}
        defaultValue={selectedValue}
        value={selectedValue}
        onChange={handleChange}
        onBlur={handleBlur}
        touched={touched}
        error={error}
        isMulti={isMulti}
        isDisabled={isDisabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        backspaceRemovesValue={backspaceRemovesValue}
        closeMenuOnSelect={closeMenuOnSelect}
        components={{ ClearIndicator: null }}
      />

      {touched && error ? <p className="error-text">{error}</p> : null}
    </div>
  )
}

export { SelectField }
